import React from "react";
import { Link, NavLink } from "react-router-dom";

const NavItem = ({ title, isActive, dropdownItems }) => {
  const hasDropdown = dropdownItems && dropdownItems.length > 0;

  return (
    <li className={`nav-item active ${isActive ? "show" : ""}`}>
      <div className="dropdown">
        {hasDropdown ? (
          <>
            <button
              className={`menu-dropdown-btn dropdown-toggle ${
                isActive ? "active" : ""
              }`}
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {title}
            </button>

            <ul className="dropdown-menu">
              {dropdownItems?.map((group, groupIndex) => (
                <div
                  key={groupIndex}
                  className={`dropdown-group group-${groupIndex + 1}`}
                >
                  {group?.items?.map((item, itemIndex) => (
                    <li
                      key={itemIndex}
                      onClick={(e) => {
                        e.preventDefault();
                        if (item.onClick) item.onClick();
                      }}
                      className="dropdown-item-wrapper"
                    >
                      {item.path ? (
                        <Link
                          to={item.path}
                          className={`dropdown-item ${
                            item.isActive ? "active" : ""
                          }`}
                        >
                          {item.label}
                        </Link>
                      ) : (
                        <a
                          className={`dropdown-item ${
                            item.isActive ? "active" : ""
                          }`}
                        >
                          {item.label}
                        </a>
                      )}
                      {/* <NavLink
                        to={item.path === undefined ? "" : ""}
                        className={`dropdown-item ${
                          item.isActive ? "active" : ""
                        }`}
                      >
                        {item.label}
                      </NavLink> */}
                    </li>
                  ))}
                </div>
              ))}
            </ul>
          </>
        ) : (
          <Link
            to={`/${title.toLowerCase()}`}
            className={`menu-dropdown-btn ${isActive ? "active" : ""}`}
          >
            {title}
          </Link>
        )}
      </div>
    </li>
  );
};

const Navigation = ({ navItems }) => {
  return (
    <div className="pages-link-with-dropdown">
      <ul className="mini-nav homepage-nav flex space-x-4">
        {navItems.map((item, index) => (
          <NavItem
            key={index}
            title={item.title}
            isActive={item.isActive}
            dropdownItems={item.dropdownItems}
          />
        ))}
      </ul>
    </div>
  );
};

export default Navigation;
